import * as angular from "angular";

export const unitsModule = angular.module("unitsModule",[]);